import React from "react";
import { rowColumn } from "../../../components/table/Table";
import { getFilterOptions } from "../../CommonFunctions";
import { assignStatusExternalOptions, assignStatusExternalSecondaryOptions } from "../../utils/assignStatusExternalOptions";

export const departmentApplicationListTable: rowColumn[] = [
  {
    label: "KIS ID",
    column: "id",
    type: "string",
    allowSort: true,
    sortOn: "Id",
  },
  {
    label: "First Name",
    column: "firstName",
    type: "string",
    allowSort: true,
    sortOn: "FirstName",
  },
  {
    label: "Last Name",
    column: "lastName",
    type: "string",
    allowSort: true,
    sortOn: "LastName",
  },
  {
    label: "Kindergarten",
    column: "fundedKinderName",
    type: "string",
    allowSort: true,
    sortOn: "FundedKinderName",
    body: (rowData) => {
      return <p className="m-0">{rowData.fundedKinderName === "Other" ? rowData.kindergartenNameOther : rowData.fundedKinderName}</p>;
    },
    isFilter: true,
    filterType: "search",
    filterKeyColumns: ["fundedKinderName", "kindergartenNameOther"],
  },
  {
    label: "Date Submitted",
    column: "dateSubmitted",
    type: "date",
    allowSort: true,
    sortOn: "DateSubmitted",
  },
  {
    label: "Status",
    column: "statusComputed",
    type: "string",
    allowSort: true,
    sortOn: "StatusComputed",
    isFilter: true,
    disableSearch: true,
    filterType: "multiselect",
    filterElements: getFilterOptions(assignStatusExternalOptions, assignStatusExternalSecondaryOptions),
  },
  {
    label: "Actions",
    body: (rowData) => <a href={`applications/${rowData.id}`}>View Details</a>,
  },
];
